import React, { useEffect, useState } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { motion, AnimatePresence } from 'framer-motion';
export function UrgencyTimer() {
  const {
    minutes,
    seconds,
    totalSeconds
  } = useCountdown(15);
  // Calculate progress (0 to 1)
  const progress = totalSeconds / 900;
  const circumference = 2 * Math.PI * 80;
  const strokeDashoffset = circumference * (1 - progress);
  // Determine urgency level with smooth transition
  const isCritical = totalSeconds < 300; // Last 5 minutes
  const criticalProgress = Math.max(0, Math.min(1, (300 - totalSeconds) / 300));
  // Smooth color transition from orange to red
  const baseColor = isCritical ? `rgba(${255}, ${Math.round(107 - 54 * criticalProgress)}, ${Math.round(53 - 53 * criticalProgress)}, 1)` : '#FF6B35';
  return <section className="relative py-16 px-4 bg-black" data-id="element-250">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-251">
        {/* Main Timer Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="relative bg-[#0A0A0A] rounded-xl border overflow-hidden" style={{
        borderColor: baseColor + '30'
      }} data-id="element-252">
          <div className="grid md:grid-cols-2 gap-8 p-8 md:p-10" data-id="element-253">
            {/* Left Side - Info */}
            <div className="flex flex-col justify-center space-y-6" data-id="element-254">
              <div className="space-y-4" data-id="element-255">
                <h3 className="text-xl md:text-2xl font-bold text-white uppercase tracking-tight" data-id="element-256">
                  ¡OFERTA DE LANZAMIENTO!
                </h3>

                <p className="text-sm text-gray-400" data-id="element-257">
                  Esta Oferta Exclusiva Termina{' '}
                  <span className="font-bold text-white" data-id="element-258">
                    HOY{' '}
                    {new Date().toLocaleDateString('es-ES', {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long'
                  }).toUpperCase()}
                  </span>
                </p>

                <div className="pt-2" data-id="element-259">
                  <p className="text-3xl md:text-4xl font-bold text-white tabular-nums" data-id="element-260">
                    {minutes}:{seconds}
                  </p>
                </div>

                <p className="text-xs text-gray-500 leading-relaxed" data-id="element-261">
                  Tu lugar estará reservado durante 15 minutos, en caso de no
                  acceder se cederá el descuento a la siguiente persona.
                </p>
              </div>

              {/* Progress Bar */}
              <div className="space-y-2" data-id="element-262">
                <div className="h-1 bg-white/5 rounded-full overflow-hidden" data-id="element-263">
                  <motion.div className="h-full rounded-full" style={{
                  backgroundColor: baseColor
                }} initial={{
                  width: '100%'
                }} animate={{
                  width: `${progress * 100}%`
                }} transition={{
                  duration: 0.5,
                  ease: 'linear'
                }} data-id="element-264" />
                </div>
              </div>
            </div>

            {/* Right Side - Circular Timer */}
            <div className="flex items-center justify-center" data-id="element-265">
              <div className="relative w-48 h-48" data-id="element-266">
                {/* SVG Circular Progress */}
                <svg className="w-full h-full -rotate-90" viewBox="0 0 180 180" data-id="element-267">
                  {/* Background Circle */}
                  <circle cx="90" cy="90" r="80" fill="none" stroke="rgba(255, 255, 255, 0.05)" strokeWidth="4" data-id="element-268" />

                  {/* Progress Circle */}
                  <motion.circle cx="90" cy="90" r="80" fill="none" stroke={baseColor} strokeWidth="4" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} animate={{
                  strokeDashoffset: strokeDashoffset
                }} transition={{
                  duration: 1,
                  ease: 'linear'
                }} data-id="element-269" />
                </svg>

                {/* Center Content */}
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-270">
                  <div className="text-center" data-id="element-271">
                    {/* Minutes and Seconds */}
                    <div className="flex items-center justify-center gap-1" data-id="element-272">
                      <AnimatePresence mode="wait" data-id="element-273">
                        <motion.div key={minutes} initial={{
                        y: 10,
                        opacity: 0
                      }} animate={{
                        y: 0,
                        opacity: 1
                      }} exit={{
                        y: -10,
                        opacity: 0
                      }} transition={{
                        duration: 0.2
                      }} className="text-4xl font-bold text-white tabular-nums" style={{
                        color: baseColor
                      }} data-id="element-274">
                          {minutes}
                        </motion.div>
                      </AnimatePresence>

                      <span className="text-3xl font-bold text-white/30" data-id="element-275">
                        :
                      </span>

                      <AnimatePresence mode="wait" data-id="element-276">
                        <motion.div key={seconds} initial={{
                        y: 10,
                        opacity: 0
                      }} animate={{
                        y: 0,
                        opacity: 1
                      }} exit={{
                        y: -10,
                        opacity: 0
                      }} transition={{
                        duration: 0.2
                      }} className="text-4xl font-bold text-white tabular-nums" style={{
                        color: baseColor
                      }} data-id="element-277">
                          {seconds}
                        </motion.div>
                      </AnimatePresence>
                    </div>

                    <div className="mt-2 text-xs uppercase tracking-widest text-gray-600" data-id="element-278">
                      minutos
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}